import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';
import { parseProfileTheme, type ProfileTheme } from '@/lib/profileTheme';

/**
 * Fetch a user's active Ditto profile theme (kind 16767).
 * Returns the parsed theme, or `undefined` if the user has no active theme.
 */
export function useProfileTheme(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery<ProfileTheme | undefined>({
    queryKey: ['profile-theme', pubkey ?? ''],
    queryFn: async (c) => {
      if (!pubkey) return undefined;

      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(3000)]);
      const [event] = await nostr.query(
        [{ kinds: [16767], authors: [pubkey], limit: 1 }],
        { signal },
      );

      return parseProfileTheme(event);
    },
    enabled: !!pubkey,
    staleTime: 5 * 60 * 1000,
  });
}
